import React, { useState } from 'react';
import Header from './components/Header.js';
import ProjectGrid from './components/ProjectGrid.js';
import About from './components/About.js';
import ProjectCase from './components/ProjectCase.js';
import MoreProjects from './components/MoreProjects.js';
import projects from './projects';
import './App.css';

function App() {
  const [selectedProject, setSelectedProject] = useState(null);
  const [isProjectCaseOpen, setIsProjectCaseOpen] = useState(false);
  const [isMoreOpen, setisMoreOpen] = useState(false);

  const handleClick = (setter) => {
    setter(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleClose = (setter) => {
    setter(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleProjectClick = (project) => {
    setSelectedProject(project);
    handleClick(setIsProjectCaseOpen);
  };

  const handleCloseClick = () => handleClose(setIsProjectCaseOpen);
  const handleMoreClick = () => handleClick(setisMoreOpen);
  const handleCloseMoreClick = () => handleClose(setisMoreOpen);

  return (
    <div className="App">
      {isProjectCaseOpen ? (
        <ProjectCase project={selectedProject} onClose={handleCloseClick} />
      ) : isMoreOpen ? (
        <MoreProjects onClose={handleCloseMoreClick} />
      ) : (
        <>
          <Header />
          <ProjectGrid projects={projects} onProjectClick={handleProjectClick} />
          <About />
          <div
            className='more-projects-link'
            role="button"
            tabIndex={0}
            onClick={handleMoreClick}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleMoreClick();
              }
            }}
            >
            <span>+</span> See offline projects
          </div>
        </>
      )}
    </div>
  );
}

export default App;